import React, {useEffect, useRef, useState} from 'react';
import './FactionUnitSkinRewardModal.css';
import {COLORS_CONFIG, PLAYER_COLORS} from '../../../configs/colors';
import PageButton from "../../elements/PageButton/PageButton";
import FactionUnitSkinsCarousel from "../../FactionUnitSkinsCarousel/FactionUnitSkinsCarousel";
import {getFactionConfig} from "../../../utils/factions/getFactionConfig";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'FactionUnitSkinRewardModal';

function FactionUnitSkinRewardModal({factionId, onClaim, onEntered, onGoToFaction}) {
  const [visible, setVisible] = useState(false);
  const enteredRef = useRef(false);

  const factionConfig = getFactionConfig(factionId);
  const resolveFactionColor = (colorKey, fallbackColor) => {
    if (colorKey === PLAYER_COLORS.BROWN) return '#7b3c00';
    if (colorKey === PLAYER_COLORS.BLUE) return '#157be0';
    return COLORS_CONFIG[colorKey] || fallbackColor;
  };
  const factionColor = resolveFactionColor(factionConfig?.colors?.[0], factionConfig?.textColor);
  const factionName = factionConfig?.name || factionId;

  useEffect(() => {
    const soundManager = MENU_SOUND_MANAGER;
    if (soundManager?.playFactionSelect && factionId) {
      soundManager.playFactionSelect(factionId);
    }

    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [factionId]);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      onClaim?.();
    }, 300);
  };

  const handleGoToFaction = () => {
    onGoToFaction?.();
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClaim();
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName !== 'opacity') return;
    if (visible && !enteredRef.current) {
      enteredRef.current = true;
      onEntered?.();
    }
  };

  if (!factionConfig) return null;

  return (
    <div
      className={`faction-unit-skin-reward-overlay ${visible ? 'faction-unit-skin-reward-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      onTransitionEnd={handleTransitionEnd}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`faction-unit-skin-reward-modal ${visible ? 'faction-unit-skin-reward-modal_visible' : ''}`}
        style={{'--faction-color': factionColor}}
      >
        <div className="faction-unit-skin-reward-content">
          <div className="faction-unit-skin-reward-carousel-wrapper">
            <FactionUnitSkinsCarousel
              factionId={factionId}
              iconColor={factionColor}
              isOwned={true}
              pageId="FactionUnitSkinRewardModal"
              selectButtonLabel="К фракции"
              isSelectDisabled={() => false}
              onSelect={handleGoToFaction}
              showDescription={false}
            />
          </div>
          <div className="faction-unit-skin-reward-info">
            <span className="faction-unit-skin-reward-title">Особый образ отрядов!</span>
            <h2 className="faction-unit-skin-reward-name" style={{color: factionColor}}>
              {factionName}
            </h2>
          </div>

          <div className="main-menu-buttons faction-unit-skin-reward-buttons">
            <PageButton onClick={handleClaim} pageId={PAGE_ID} buttonId="claim_reward">
              Принять дар
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FactionUnitSkinRewardModal;
